import React from "react";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface UpdateButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onUpdate: () => void;
  variant?: "text" | "outlined" | "contained";
}

const UpdateButton: React.FC<UpdateButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onUpdate,
  variant = "outlined",
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="update-button"
      testId="update"
      variant={variant}
      startIcon={<AutorenewIcon />}
      onClick={onUpdate}
    />
  );
};
export default UpdateButton;
